import { render, staticRenderFns } from "./CustomerOverview.vue?vue&type=template&id=917ee862&scoped=true"
import script from "./CustomerOverview.vue?vue&type=script&lang=js"
export * from "./CustomerOverview.vue?vue&type=script&lang=js"
import style0 from "./CustomerOverview.vue?vue&type=style&index=0&id=917ee862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ee862",
  null
  
)

export default component.exports